import { useCallback } from 'preact/hooks'
import { Text } from 'preact-i18n'

import { Modal, Grid, Transition } from 'semantic-ui-react'
import { Logo, ScanditButton, Link, ScanditSDKVersionText } from '../atoms'
import IntroForm from '../molecules/IntroForm/IntroForm'
import { useStore } from '../../store'

const IntroFormWithStore = () => {
  const store = useStore()
  return (
    <IntroForm
      colorInvertedValue={store.initialOptionsStore.colorInvertedValue.value}
      colorInvertedState={store.initialOptionsStore.colorInvertedEnabled.value}
      scannerMode={store.initialOptionsStore.scannerMode.value}
      onColorInvertedChange={useCallback((data) => store.initialOptionsStore.setColorInverted(data.colorInverted), [])}
      onScannerModeChange={useCallback((data) => {
        store.initialOptionsStore.setScannerMode(data.scannerMode)
      }, [])}
    />
  )
}

const IntroModal = () => {
  const store = useStore()
  const open =
    !store.initialOptionsStore.launched.value &&
    !store.initialOptionsStore.isSDKLoading.value &&
    !store.errorsStore.hasPartialSupport.value &&
    !store.errorsStore.hasUnsupportedBrowserMessage.value
  return (
    <Transition visible={open} animation="fade" duration={600} onHide={() => {}} transitionOnMount>
      <Modal basic open={open} id="intro-modal">
        <Modal.Content>
          <Grid centered>
            <Modal.Description className="sdk-description">
              <Logo />
              <br />
              <br />
              <p class="subtitle uppercase">
                <Text id="intro.title" />
              </p>
              <ScanditSDKVersionText />
              <br />
              <p>
                <Text id="intro.sdkDescription" />
              </p>
              <p>
                <Text id="intro.moreInfo1" />{' '}
                <Link href="https://www.scandit.com/products/sdk-web/" target="_blank" rel="noopener">
                  <u>
                    <Text id="intro.moreInfo2" />
                  </u>
                </Link>
                .
              </p>
              <p>
                <Text id="intro.selectModeMessage" />
              </p>
            </Modal.Description>
          </Grid>
          <IntroFormWithStore />
        </Modal.Content>
        <Modal.Actions>
          <Grid centered>
            <ScanditButton disabled={!store.initialOptionsStore.canStart.value} onClick={() => store.launch()} inverted>
              <Text id="actions.start" />
            </ScanditButton>
          </Grid>
        </Modal.Actions>
        <p class="copyright-text">
          Copyright Scandit AG
          <br />
          Scandit's products are patent protected. <br />
          Details at{' '}
          <Link href="https://scandit.com/patents" target="_blank" rel="noopener">
            scandit.com/patents
          </Link>
        </p>
      </Modal>
    </Transition>
  )
}

export default IntroModal
